import { Connection, PublicKey } from '@solana/web3.js';
import React from 'react';
import messageService, {Message} from "./Messages";
import { Program, Wallet } from '@project-serum/anchor';
import { WalletNotConnectedError } from '@solana/wallet-adapter-base';
import { getProgram, sortMessages } from "./utils";
import FlipMove from 'react-flip-move';

require('./index.css');


interface Props{
  messages: Message[],
  lookup: Function,
}

class MessageList extends React.Component<Props, { rendered: boolean }> {
  constructor(props: Props) {
    super(props)
    this.state = { rendered: false }
  }


  render() {
    const messageList =
      this.props.messages.map((message) => {
        return (
            <li className="item" key={message.ts}>
              <span className="rawMessage"> {message.text} </span>
              <br></br> 
              <span className="time"> {(new Date(parseInt(message.ts) * 1000)).toLocaleString()} </span>
              {/* <br></br> */}
              <span className="creator">creator: 
              <button className="lookupButton" onClick = {() => this.props.lookup(message.creator)}>  {message.creator.toString()} </button>
              {/* <br /> */}
              <a href={`https://explorer.solana.com/address/${message.creator.toString()}`} target="_blank" rel="noopener noreferrer"> explorer </a>
              <button className="copyButton" data-tip='custom show' data-for="doCopy" data-event='click'
                onClick={() =>  {
                  navigator.clipboard.writeText(message.creator.toString());
                }
                }
              >
                Copy
              </button>
              </span>
            </li>
        )
    }
    )

    return (
        <div className="scroller">
        <ul id="messageList" className="list-group">
        <FlipMove>
          {messageList}
          </FlipMove>

        </ul>

        </div>
    )
  }
}

interface ViewProps {
  publicKeys: PublicKey[],
  wallet: Wallet,
  global: boolean,
  connection: Connection,
  lookup: Function,
  // program: Program
}

interface ViewState {
  loading: boolean,
  connection: Connection,
  messages:  Message[],
  publicKeys: PublicKey[],
  program: Program,
  global: boolean,
  interval,

}

class MessageView extends React.Component<ViewProps, ViewState> {
    constructor(props: ViewProps) {
        super(props);
        const wallet = props.wallet;
        // const connection = new Connection('https://api.mainnet-beta.solana.com', 'confirmed');
        const connection = props.connection;
        if (!wallet) throw new WalletNotConnectedError();
        const program = getProgram(wallet, connection);

        this.state = { loading: true ,
        connection: connection,
        messages: [],
        publicKeys: props.publicKeys,
        program: program, 
        global: props.global,
        interval:undefined
        };
        this.refreshData = this.refreshData.bind(this);
    }


    async refreshData(): Promise<void> {
      let mergedMessages: Message[];
      if (this.state.global) {
        mergedMessages = await messageService.reportGlobalMessages(this.state.program);
      }
      else if (this.state.publicKeys) {
        const messagesInfos = await Promise.all(this.state.publicKeys.map(key => messageService.reportMessagesAndPage(this.state.program, key)));
        const allMessages = messagesInfos.map(x => x.messages);
        mergedMessages = allMessages.reduce((accumulator, value) => accumulator.concat(value), []);
      }
      else {
        mergedMessages = [];
      }
      this.setState({messages: mergedMessages.sort(sortMessages), loading: false});
    }

    componentDidMount() {
      let interval = setInterval(this.refreshData, 1000);
      this.setState({ interval: interval })
    }
    
    componentWillUnmount(){
      clearInterval(this.state.interval)
    }


    render() {
        return (
        <div className="MessageView">
          <header className="MessageView-header">
              {!this.state.loading ? <MessageList messages={this.state.messages} lookup={this.props.lookup} /> : "loading...."}
          </header>
        </div>
    );
    }

};

export default MessageView;
